import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import './index.scss'

import { setLanguage, getLanguageInfos, getLanguageInfo } from '../../language/actions'

// Elements
import Footer from '../../shared/components/Footer'
import Divider from '../../shared/elements/divider'

class Auth extends Component {

  constructor (props) {
    super(props)
    this.state = {
      isLanguageOpen: false
    }
    this.toggleLanguageMenu = this.toggleLanguageMenu.bind(this)
    this.changeLanguage = this.changeLanguage.bind(this)
    this.changeLanguageInfo = this.changeLanguageInfo.bind(this)
    this.renderLangNames = this.renderLangNames.bind(this)
  }

  changeLanguage (e) {
    e.preventDefault()
    let lang = window.localStorage.getItem('user_language')
    if (lang === undefined || lang === null) {
      lang = 'Danish'
    }
    this.props.setLanguage(lang)
  }

  toggleLanguageMenu (open) {
    open = (typeof open.target !== 'undefined') ? !this.state.isLanguageOpen : open
    this.setState({
      isLanguageOpen: open
    })
  }

  changeLanguageInfo (langInfo) {
    this.toggleLanguageMenu({target: false})
    let lang = langInfo.LanguageName
    this.props.setLanguage(lang)
  }

  renderLangNames (val, key) {
    return (
      <div key={key} className='langname'>
        <img src={val.Image} />
        <label><a onClick={this.changeLanguageInfo.bind(this, val)} href='#'> {val.SelfLangName}</a></label>
      </div>
    )
  }

  render () {
    let activeLang = window.localStorage.getItem('user_language') // (window.localStorage.getItem('user_language') === 'Danish') ? 'Danish' : 'English'
    let langInfo = this.props.getLanguageInfo(activeLang)
    let languageTriggerClass = 'fa fa-chevron-down'
    if (activeLang === undefined || activeLang === null) {
      activeLang = 'Danish'
    }
    let languageMenu = ''
    if (this.state.isLanguageOpen) {
      languageTriggerClass = 'fa fa-chevron-up'
      let langInfos = this.props.getLanguageInfos()
      languageMenu = (
        <div className='dropdown__menu'>
          {langInfos.map(this.renderLangNames)}
        </div>
      )
    }

    return (
      <div className='auth__screen'>
        <div className='auth-container'>
          <div className='scroll-container'>
            <div className='top_header'>
              <img src='/images/logo.png' className='logo' />
              <Divider vertical />
              <div className='info'>
                <div onClick={this.toggleLanguageMenu} className='language_trigger'>
                  <label className='language'>{langInfo.LanguageCode}</label>
                  <label><i className={languageTriggerClass} /></label>
                </div>
                {languageMenu}
              </div>
            </div>
            {/* <Null><Header router={this.props.router} /></Null> */}
            <div className='auth__screen--inner'>
              {this.props.children}
            </div>
          </div>
          <Footer />
        </div>
      </div>
    )
  }

}

Auth.propTypes = {
  setLanguage: PropTypes.func.isRequired,
  getLanguageInfos: PropTypes.func.isRequired,
  getLanguageInfo: PropTypes.func.isRequired
}

function mapStateToProps (state) {
  return {
    auth: state.auth
  }
}

export default connect(mapStateToProps, {
  setLanguage,
  getLanguageInfos,
  getLanguageInfo
})(Auth)



// WEBPACK FOOTER //
// ./src/app/pages/Auth/index.js